import type { JiraCustomRemoteIssueLink } from '../../types';

export const isJiraCustomRemoteIssueLink = (entity: any): entity is JiraCustomRemoteIssueLink =>
	entity.__typename === 'JiraCustomRemoteIssueLink';

export const getJiraCustomRemoteIssueLink = (link: JiraCustomRemoteIssueLink): string | null =>
	link?.href ?? null;
